// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-containers-___Target__button___XWmtr {
  background-color: transparent;
  border: none;
  border-radius: 3px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  color: #ffffff;
  padding: 0.75em 1em;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  transition: all 0.15s cubic-bezier(0.35, 0, 0.25, 1);
}
.src-styles-containers-___Target__button___XWmtr.src-styles-containers-___Target__success___QDTUU {
  background-color: #4ca92f;
  color: #ffffff;
}
.src-styles-containers-___Target__button___XWmtr.src-styles-containers-___Target__success___QDTUU:hover {
  background-color: #3a8124;
  color: #ffffff;
}
.src-styles-containers-___Target__button___XWmtr.src-styles-containers-___Target__alert___BpC6V {
  background-color: #ff401e;
  color: #ffffff;
}
.src-styles-containers-___Target__button___XWmtr.src-styles-containers-___Target__alert___BpC6V:hover {
  background-color: #ea2400;
  color: #ffffff;
}
.src-styles-containers-___Target__button___XWmtr:disabled,
.src-styles-containers-___Target__button___XWmtr:disabled:hover {
  background-color: rgba(150, 150, 150, 0.5);
}
.src-styles-containers-___Target__inputField___TVbQm {
  font-size: 1.5em;
  border: 1px solid rgba(150, 150, 150, 0.5);
  border-radius: 3px;
  padding: 0.2em;
  min-width: 300px;
  width: 100%;
}
.src-styles-containers-___Target__left___S6zhu {
  min-height: calc(100vh - 4em);
  padding: 2em;
  border-right: 1px solid rgba(150, 150, 150, 0.5);
}
.src-styles-containers-___Target__filter___Rk1OE input[type=search] {
  width: 100%;
}
.src-styles-containers-___Target__buttons___qwF3x {
  margin-top: 1em;
  display: flex;
  justify-content: center;
}
label > input[type=checkbox] {
  margin-right: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mixins.less","webpack://./src/styles/containers/Target.less"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,mBAAA;EACA,2CAAA;EACA,oDAAA;ACDF;ADGE;EACE,yBAAA;EACA,cAAA;ACDJ;ADGI;EACE,yBAAA;EACA,cAAA;ACDN;ADKE;EACE,yBAAA;EACA,cAAA;ACHJ;ADKI;EACE,yBAAA;EACA,cAAA;ACHN;ADOE;;EACE,0CAAA;ACJJ;ADQA;EACE,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;ACNF;AAlCA;EACE,6BAAA;EACA,YAAA;EACA,gDAAA;AAoCF;AAjCA;EAEI,WAAA;AAkCJ;AA9BA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AAgCF;AA7BA;EACE,iBAAA;AA+BF","sourcesContent":["@import './variables.less';\n\n.button {\n  background-color: transparent;\n  border: none;\n  border-radius: 3px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  color: @color-main-white;\n  padding: 0.75em 1em;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  transition: @transition;\n  \n  &.success {\n    background-color: @color-main-green;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-green, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &.alert {\n    background-color: @color-main-red;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-red, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &:disabled, &:disabled:hover {\n    background-color: @color-main-gray;\n  }\n}\n\n.inputField {\n  font-size: 1.5em;\n  border: 1px solid @color-main-gray;\n  border-radius: 3px;\n  padding: 0.2em;\n  min-width: 300px;\n  width: 100%;\n}\n","@import '../variables.less';\n@import '../mixins.less';\n\n.left {\n  min-height: calc(~\"100vh\" - @height-header);\n  padding: 2em;\n  border-right: 1px solid @color-main-gray;\n}\n\n.filter {\n  input[type=search] {\n    width: 100%;\n  }\n}\n\n.buttons {\n  margin-top: 1em;\n  display: flex;\n  justify-content: center;\n}\n\nlabel > input[type=checkbox] {\n  margin-right: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export var button = `src-styles-containers-___Target__button___XWmtr`;
export var success = `src-styles-containers-___Target__success___QDTUU`;
export var alert = `src-styles-containers-___Target__alert___BpC6V`;
export var inputField = `src-styles-containers-___Target__inputField___TVbQm`;
export var left = `src-styles-containers-___Target__left___S6zhu`;
export var filter = `src-styles-containers-___Target__filter___Rk1OE`;
export var buttons = `src-styles-containers-___Target__buttons___qwF3x`;
export default ___CSS_LOADER_EXPORT___;
